import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { tvProgramDetail, programBoardList } from '@/network/apis/apiUri';
import useAxios from '@/network/useAxios';
import '../tv/css/tv_program_intro.scss';

function TvProgramIntro(props) {
  const { setSubLocation, title, mode } = props;
  const location = useLocation();

  const programId = location.pathname.split('/')[2];
  const boardId = location.pathname.split('/')[4];

  const [programDetailItem] = useAxios(tvProgramDetail, [programId], { program_id: programId, lan_code: mode }, true);
  const [detailItem] = useAxios(
    programBoardList,
    [boardId],
    {
      board_id: boardId,
      lan_code: mode,
      page_info: {
        row_count: 2,
        number: 0,
      },
    },
    true
  );

  const { data } = detailItem;

  useEffect(() => {
    setSubLocation(location.pathname);
  }, []);

  return (
    <>
      <div id="TvProgramIntro" className="tvProgramIntro">
        <section className="tvProgramIntro_section">
          {title &&
            title?.data?.item?.map((v, i) => {
              if (v.board_id === parseInt(boardId)) {
                return (
                  <h2 className="tvProgramIntro_section_title" key={i}>
                    {v.title}
                  </h2>
                );
              }
              return null;
            })}

          {programDetailItem?.data?.content[0]?.text.replace(/(?:\r\n|\r|\n)/g, '<br />') !== '<p><br></p>' && (
            <div className="info">
              <p
                className="info_content"
                dangerouslySetInnerHTML={{
                  __html: programDetailItem?.data?.content[0]?.text?.replace(/(?:\r\n|\r|\n)/g, '<br />'),
                }}
              />
            </div>
          )}
          {data?.item?.map((v) => {
            if (
              (v.is_open_allow && v.title.toUpperCase().indexOf('HOST') !== -1) ||
              (v.is_open_allow && v.title.indexOf('호스트') !== -1)
            ) {
              return (
                v.content && (
                  <div className="tvProgramIntro_section_content" key={v.board_item_id * v.order}>
                    <h2 className="tvProgramIntro_section_title style_subTitle">{v.title}</h2>
                    <ul
                      className="host"
                      dangerouslySetInnerHTML={{ __html: v.content?.replace(/(?:\r\n|\r|\n)/g, '<br />') }}
                    />
                  </div>
                )
              );
            }
            return null;
          })}
        </section>
        {data?.item?.map((v, i) => {
          if (
            (v.is_open_allow && v.title.toUpperCase().indexOf('STAFF') !== -1) ||
            (v.is_open_allow && v.title.indexOf('스태프') !== -1) ||
            (v.is_open_allow && v.title.indexOf('스탭') !== -1)
          ) {
            return (
              <section className="tvProgramIntro_section" key={v.board_item_id * v.order + i}>
                <div className="box">
                  <h3 className="box_title">{v.title}</h3>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: v.content?.replace(/(?:\r\n|\r|\n)/g, '<br />'),
                    }}
                  />
                </div>
              </section>
            );
          }
          return null;
        })}
      </div>
    </>
  );
}

export default TvProgramIntro;
